var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "ListFilter",
                {
                  attrs: {
                    FILTER_ITEMS: _vm.FILTER_ITEMS,
                    handleSearch: _vm.handleSearch,
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:coupon:create"],
                          expression: "['admin:coupon:create']",
                        },
                      ],
                      staticClass: "mr10",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.conponAddOredit("ADD")
                        },
                      },
                    },
                    [_vm._v("新增优惠券")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "消费券名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "voucherTypeDesc",
                  label: "券类型",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "marketingParty",
                  label: "营销方",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              Number(scope.row.marketingParty) === 1
                                ? "入驻商户"
                                : "平台"
                            ) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "isIntegralExchange",
                  label: "是否用于积分兑换",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.isIntegralExchange ? "是" : "否") +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "internalRemark",
                  label: "内部备注",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponDiscountInfo",
                  label: "优惠信息",
                  "min-width": "180",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.couponDiscountInfo
                          ? _vm._l(
                              scope.row.couponDiscountInfo.split("\n"),
                              function (info, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(_vm._s(info)),
                                ])
                              }
                            )
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalQuantity",
                  label: "发放张数",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "领取统计", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "总领取：" + _vm._s(scope.row.receiveCount || 0)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "主动领取：" +
                              _vm._s(_vm.getManualReceiveCount(scope.row))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "后台发放：" +
                              _vm._s(scope.row.backendIssueCount || 0)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "购买发放：" +
                              _vm._s(scope.row.purchaseIssueCount || 0)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "积分兑换：" +
                              _vm._s(scope.row.integralExchangeIssueCount || 0)
                          ),
                        ]),
                        _vm._v(" "),
                        Number(scope.row.isGenerateCode) === 1
                          ? _c("div", [
                              _vm._v(
                                "券码绑定：" +
                                  _vm._s(scope.row.codeBindIssueCount || 0)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "validityStart",
                  label: "有效期",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.validityType == 1
                          ? _c("div", [
                              _vm._v(
                                "领取后" + _vm._s(scope.row.validityDays) + "天"
                              ),
                            ])
                          : [
                              _c("div", [
                                _vm._v(_vm._s(scope.row.validityStart)),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(scope.row.validityEnd)),
                              ]),
                            ],
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusDesc",
                  label: "状态",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "codeGenStatus",
                  label: "券码生成状态",
                  "min-width": "120",
                  formatter: _vm.formatCodeGenStatus,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "distributionCustomersName",
                  label: "适用供应商",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "enableStressTest",
                  label: "压测模式",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.enableStressTest === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "small" } },
                              [_vm._v("启用")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("未启用")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "enableParamEncryption",
                  label: "参数加密",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.enableParamEncryption === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "small" } },
                              [_vm._v("启用")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("未启用")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "250", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:detail"],
                                expression: "['admin:coupon:detail']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.detail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:statistics"],
                                expression: "['admin:coupon:statistics']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.effectAnalysis(scope.row)
                              },
                            },
                          },
                          [_vm._v("数据分析")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:copy:link"],
                                expression: "['admin:coupon:copy:link']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.copyLink(scope.row)
                              },
                            },
                          },
                          [_vm._v("复制链接")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:update"],
                                expression: "['admin:coupon:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.conponAddOredit("EDIT", scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:copy"],
                                expression: "['admin:coupon:copy']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.conponAddOredit("COPY", scope.row)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                        _vm._v(" "),
                        Number(scope.row.isGenerateCode) === 1
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  loading: _vm.downloadingCouponIds.includes(
                                    scope.row.id
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadCodes(scope.row)
                                  },
                                },
                              },
                              [_vm._v("下载券码")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        Number(scope.row.isGenerateCode) === 1 &&
                        Number(scope.row.codeGenStatus) === 3
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  loading: _vm.retryingCouponIds.includes(
                                    scope.row.id
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.retryGenerateCodes(scope.row)
                                  },
                                },
                              },
                              [_vm._v("重新获取券码")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status !== 3
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:coupon:close"],
                                    expression: "['admin:coupon:close']",
                                  },
                                ],
                                staticClass: "err",
                                staticStyle: { color: "red" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.close(scope.row)
                                  },
                                },
                              },
                              [_vm._v("关闭")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:coupon:delete"],
                                expression: "['admin:coupon:delete']",
                              },
                            ],
                            staticClass: "err",
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "text-align": "right", "padding-top": "20px" },
            attrs: {
              "page-sizes": [20, 40, 60, 80],
              "page-size": _vm.pageData.limit,
              "current-page": _vm.pageData.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("DeleteCouponVue", {
        ref: "DeleteCouponVueRef",
        on: { refresh: _vm.handleSearch },
      }),
      _vm._v(" "),
      _c("CloseCouponVue", {
        ref: "CloseCouponVueRef",
        on: { refresh: _vm.handleSearch },
      }),
      _vm._v(" "),
      _c("CopyLinkVue", { ref: "CopyLinkVueRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }